import {
  SET_NOTIFICATION,
  setNotification,
  removeNotification,
} from "../../actions/notification.action";

export const notificationMiddleware = () => (next: any) => (action: any) => {
  if (action.type.includes(SET_NOTIFICATION)) {
    const { payload, meta } = action;
    const id = new Date().getMilliseconds();

    // enrich the original payload with an id
    const notification = {
      id,
      massage: payload,
    };

    // fire a new action with the enriched payload
    // note: the payload is an object
    next(setNotification(notification, meta.feature));

    // dispatch a clear action after a given time
    setTimeout(() => {
      next(removeNotification(id, meta.feature));
    }, 10000);
  } else {
    next(action);
  }
};
